export const colors = {
    antracit: {
        name: 'Антрацит',
        hex: '#ccf'
    },
    husky: {
        name: 'Хаски',
        hex: '#d64a4a'
    },
    autumn: {
        name: 'Осень',
        hex: '#4a76d6'
    },
    old_castel: {
        name: 'Старый замок',
        hex: '#1d1d1d'
    },
    arabian_night: {
        name: 'Арабская ночь',
        hex: '#d6cd4a'
    },
    kair: {
        name: 'Каир',
        hex: '#d6954a'
    },
    white: {
        name: 'Белый',
        hex: '#442c19'
    },
    black: {
        name: 'Черный',
        hex: '#000000'
    },
    brown: {
        name: 'Коричневый',
        hex: '#442c18'
    },
    dolomit: {
        name: 'Доломит',
        hex: '#442c18'
    },
    gray: {
        name: 'Серый',
        hex: '#cca'
    },
    whitee_blackk: {
        name: 'Белый с черным',
        hex: '#ccc'
    },
    nut: {
        name: 'Орех',
        hex: '#cff'
    },
    platan: {
        name: 'Платан',
        hex: '#fcc'
    },
    cedar: {
        name: 'Кедр',
        hex: '#acc'
    },
    white_black: {
        name: 'Белый с черным',
        hex: '#ccc'
    },
    wenge: {
        name: 'Венге',
        hex: '#fac'
    },
    stepnyak: {
        name: 'Степняк',
        hex: '#caf'
    },
    shungite: {
        name: 'Шунгит',
        hex: '#cfa'
    },
    basalt: {
        name: 'Базальт',
        hex: '#aff'
    },
    // shungite: {
    //     name: 'shungite',
    //     hex: '#ffa'
    // },
    maple: {
        name: 'Клен',
        hex: '#faf'
    }
    
}

export const allGroups = {
    abris: {
        name: 'Абрис',
        images: [{
            isDefault: true,
            name: "Абрис",
            pathName: "abris"
        }],
        factures: {
            granit: {
                isDefault: true,
                name: 'Гранит',
                pathName: "granit",
                collections:{
                    colormix: {
                        isDefault: true,
                        name: 'Колормикс',
                        pathName: 'colormix',
                        depth: {
                            isDefault: true,
                            60:{
                                isDefault: true,
                                default: 'husky',
                                colors: [
                                    {colorName: 'husky', border: 'border_swivel_500x200x80_granit_white'}, 
                                    {colorName: 'autumn', border: 'border_sidewalk_1000x200x80_granit_autumn'}, 
                                    {colorName: 'antracit', border: 'border_sidewalk_1000x200x80_granit_antracit'}
                                ]
                            },
                        }
                    },
                    monocolor: {
                        name: 'Моноцвет',
                        pathName: 'monocolor',
                        depth: {
                            60:{
                                isDefault: true,
                                default: 'gray',
                                colors: [
                                    {colorName: 'gray', border: 'border_sidewalk_1000x200x80_gray'}, 
                                    {colorName: 'white', border: 'border_swivel_500x200x80_granit_white'}, 
                                    {colorName: 'black', border: 'border_swivel_500x200x80_granit_white'}
                                ]
                            }
                        }
                    },
                }
            },
            sleek: {
                name: "Гладкий",
                pathName: "sleek",
                collections: {
                    colormix: {
                        isDefault: true,
                        name: 'Колормикс',
                        pathName: 'colormix',
                        depth: {
                            60:{
                                isDefault: true,
                                default: 'antracit',
                                colors: [{colorName: 'antracit', border: 'border_sidewalk_1000x200x80_gray'}]
                            },
                        }
                    },
                }
            },
            marble: {
                name: "Мрамор",
                pathName: "marble",
                collections: {
                    doublecolor: {
                        isDefault: true,
                        name: 'Двухцветная',
                        pathName: 'doublecolor',
                        depth: {
                            60:{
                                isDefault: true,
                                default: 'white_black',
                                colors: [{colorName: 'white_black', border: 'border_swivel_500x200x80_granit_white'}]
                            },
                        }
                    },
                }
            },
			artificial_stone: {
                name: "Искусственный камень",
                pathName: "artificial_stone",
                collections: {
                    colormix: {
                        isDefault: true,
                        name: 'Колормикс',
                        pathName: 'colormix',
                        depth: {
                            60:{
                                isDefault: true,
                                default: 'dolomit',
                                colors: [{colorName: 'dolomit', border: 'border_sidewalk_1000x200x80_gray'}]
                            },
                        }
                    },
                }
			}
        }
    },
    arbor: {
        name: 'Арбор',
        images: [{
            isDefault: true,
            name: "Арбор",
            pathName: "arbor"
        }],
        factures: {
            arbor: {
                isDefault: true,
                name: 'Арбор',
                pathName: 'arbor',
                collections:{
                    colormix: {
                        isDefault: true,
                        name: 'Колормикс',
                        pathName: 'colormix',
                        depth: {
                            60:{
                                isDefault: true,
                                default: 'nut',
                                colors: [
                                    {colorName: 'nut', border: 'border_sidewalk_1000x200x80_brown'}, 
                                    {colorName: 'platan', border: 'border_sidewalk_1000x200x80_brown'}, 
                                    {colorName: 'cedar', border: 'border_sidewalk_1000x200x80_brown'}, 
                                    {colorName: 'wenge', border: 'border_sidewalk_1000x200x80_brown'}
                                ]
                            },
                        }
                    }
                }
            },
        }
    },
    // classico: {
    //     name: 'Классико',
    //     images: [{
    //         isDefault: true,
    //         name: "Классико",
    //         pathName: "classico"
    //     }],
    //     factures: {
    //         sleek: {
    //             isDefault: true,
    //             name: "Гладкий",
    //             pathName: 'sleek',
    //             collections: {
    //                 colormix: {
    //                     isDefault: true,
    //                     name: 'Колормикс',
    //                     pathName: 'colormix',
    //                     depth: {
    //                         40:{
    //                             isDefault: true,
    //                             default: 'autumn',
    //                             colors: [{colorName: 'autumn', border: 'border_sidewalk_1000x200x80_granit_autumn'}]
    //                         },
    //                         60:{
    //                             default: 'husky',
    //                             colors: [{colorName: 'husky', border: 'border_sidewalk_1000x200x80_granit_husky'}]
    //                         },
    //                     }
    //                 },
    //             }
    //     },
    //     }
    // }, 
    litos: {
        name: 'Литос',
        images: [{
            isDefault: true,
            name: "Литос",
            pathName: "litos"
        }],
        factures: {
			artificial_stone: {
                isDefault: true,
                name: "Искусственный камень",
                pathName: 'artificial_stone',
                collections: {
                    colormix: {
                        isDefault: true,
                        name: 'Колормикс',
                        pathName: 'colormix',
                        depth: {
                            60:{
                                isDefault: true,
                                default: 'dolomit',
                                colors: [
                                    {colorName: 'dolomit', border: 'border_sidewalk_1000x200x80_gray'}, 
                                    {colorName: 'stepnyak', border: 'border_sidewalk_1000x200x80_stepnyak'}, 
                                    {colorName: 'shungite', border: 'border_sidewalk_1000x200x80_gray'}
                                ]
                            },
                        }
                    },
                }
			}
        }
    },
    parquet: {
        name: 'Паркет',
        images: [{
            isDefault: true,
            name: "Паркет 1",
            pathName: "parquet_1"
        },
        {
            name: "Паркет 2",
            pathName: "parquet_2"
        },
        {
            name: "Паркет 3",
            pathName: "parquet_3"
        }],
        factures: {
			granit: {
                isDefault: true,
                name: 'Гранит',
                collections:{
                    colormix: {
                        isDefault: true,
                        name: 'Колормикс',
                        pathName: 'colormix',
                        depth: {
                            60:{
                                isDefault: true,
                                default: 'arabian_night',
                                colors: [{colorName: 'arabian_night', border: 'border_swivel_500x200x80_arabian_night'}]
                            },
                        }
                    }
                }
			}
        }
    },
    petra: {
        name: 'Петра',
        images: [{
            isDefault: true,
            name: "Петра",
            pathName: "petra"
        }],
        factures: {
			granit: {
                isDefault: true,
                name: 'Гранит',
                pathName: 'granit',
                collections:{
                    colormix: {
                        isDefault: true,
                        name: 'Колормикс',
                        pathName: 'colormix',
                        depth: {
                            60:{
                                isDefault: true,
                                default: 'husky',
                                colors: [{colorName: 'husky', border: 'border_sidewalk_1000x200x80_granit_husky'}]
                            },
                        }
                    }
                }
			},
            artificial_stone: {
                name: "Искусственный камень",
                pathName: 'artificial_stone',
                collections: {
                    colormix: {
                        isDefault: true,
                        name: 'Колормикс',
                        pathName: 'colormix',
                        depth: {
                            60:{
                                isDefault: true,
                                default: 'dolomit',
                                colors: [
                                    {colorName: 'dolomit', border: 'border_sidewalk_1000x200x80_gray'}, 
                                    {colorName: 'basalt', border: 'border_sidewalk_1000x200x80_gray'}, 
                                    {colorName: 'shungite', border: 'border_sidewalk_1000x200x80_gray'},
                                    {colorName: 'stepnyak', border: 'border_sidewalk_1000x200x80_stepnyak'}
                                ]
                            },
                        }
                    },
                }
        }
        }
    },
    rectangle: {
        name: 'Прямоугольник',
        images: [{
            isDefault: true,
            name: "Прямоугольник 1",
            pathName: "rectangle_1"
        },
        {
            name: "Прямоугольник 2",
            pathName: "rectangle_2"
        }],
        factures: {
			granit: {
                isDefault: true,
                name: 'Гранит',
                pathName: 'granit',
                collections:{
                    colormix: {
                        isDefault: true,
                        name: 'Колормикс',
                        pathName: 'colormix',
                        depth: {
                            60:{
                                isDefault: true,
                                default: 'arabian_night',
                                colors: [
                                    {colorName: 'arabian_night', border: 'border_swivel_500x200x80_granit_arabian_night'}, 
                                    {colorName: 'husky', border: 'border_sidewalk_1000x200x80_granit_husky'}
                                ]
                            },
                        }
                    },
                    monocolor: {
                        name: 'Моноцвет',
                        pathName: 'monocolor',
                        depth: {
                            60:{
                                isDefault: true,
                                default: 'gray',
                                colors: [{colorName: 'gray', border: 'border_sidewalk_1000x200x80_gray'}]
                            }
                        }
                    },
                }
			},
            artificial_stone: {
                name: "Искусственный камень",
                pathName: 'artificial_stone',
                collections: {
                    colormix: {
                        isDefault: true,
                        name: 'Колормикс',
                        pathName: 'colormix',
                        depth: {
                            60:{
                                isDefault: true,
                                default: 'stepnyak',
                                colors: [
                                    {colorName: 'stepnyak', border: 'border_sidewalk_1000x200x80_stepnyak'}, 
                                    {colorName: 'dolomit', border: 'border_sidewalk_1000x200x80_gray'}
                                ]
                            },
                        }
                    },
                }
            }
        }
    },
    regata: {
        name: 'Регата',
        images: [{
            isDefault: true,
            name: "Регата",
            pathName: "regata"
        }],
        factures: {
            artificial_stone: {
                isDefault: true,
                name: "Искусственный камень",
                pathName: 'artificial_stone',
                collections: {
                    colormix: {
                        isDefault: true,
                        name: 'Колормикс',
                        pathName: 'colormix',
                        depth: {
                            60:{
                                isDefault: true,
                                default: 'shungite',
                                colors: [
                                    {colorName: 'shungite', border: 'border_swivel_500x200x80_granit_white'}, 
                                    {colorName: 'dolomit', border: 'border_swivel_500x200x80_granit_white'}
                                ]
                            },
                        }
                    },
                }
            }
        }
    },
    rigel: {
        name: 'Ригель',
        images: [{
            isDefault: true,
            name: "Ригель",
            pathName: "rigel"
        }],
        factures: {
            artificial_stone: {
                isDefault: true,
                name: "Искусственный камень",
                pathName: 'artificial_stone',
                collections: {
                    colormix: {
                        isDefault: true,
                        name: 'Колормикс',
                        pathName: 'colormix',
                        depth: {
                            80:{
                                isDefault: true,
                                default: 'shungite',
                                colors: [{colorName: 'shungite', border: 'border_swivel_500x200x80_granit_white'}]
                            },
                        }
                    },
                }
            }
        }
    },
    old_town: {
        name: 'Старый город',
        images: [{
            isDefault: true,
            name: "Старый город",
            pathName: "old_town"
        }],
        factures: {
            granit: {
                name: 'Гранит',
                pathName: 'granit',
                collections:{
                    colormix: {
                        isDefault: true,
                        name: 'Колормикс',
                        pathName: 'colormix',
                        depth: {
                            40:{
                                isDefault: true,
                                default: 'antracit',
                                colors: [
                                    {colorName: 'antracit', border: 'border_sidewalk_1000x200x80_granit_antracit'}, 
                                    {colorName: 'husky', border: 'border_sidewalk_1000x200x80_granit_husky'}, 
                                    {colorName: 'autumn', border: 'border_sidewalk_1000x200x80_granit_autumn'}, 
                                    {colorName: 'old_castel', border: 'border_sidewalk_1000x200x80_granit_old_castel'}
                                ]
                            },
                            60:{
                                default: 'autumn',
                                colors: [
                                    {colorName: 'autumn', border: 'border_sidewalk_1000x200x80_granit_autumn'}, 
                                    {colorName: 'antracit', border: 'border_sidewalk_1000x200x80_granit_antracit'}, 
                                    {colorName: 'husky', border: 'border_sidewalk_1000x200x80_granit_husky'},
                                    {colorName: 'old_castel', border: 'border_sidewalk_1000x200x80_granit_old_castel'}, 
                                    {colorName: 'arabian_night', border: 'border_swivel_500x200x80_granit_arabian_night'}, 
                                    {colorName: 'kair', border: 'border_swivel_500x200x80_granit_arabian_night'}
                                ]
                            },
                        }
                    },
                    monocolor: {
                        name: 'Моноцвет',
                        pathName: 'monocolor',
                        depth: {
                            40:{
                                isDefault: true,
                                default: 'white',
                                colors: [{colorName: 'white', border: 'border_swivel_500x200x80_granit_white'}]
                            },
                            60:{
                                default: 'brown',
                                colors: [
                                    {colorName: 'brown', border: 'border_sidewalk_1000x200x80_brown'}, 
                                    {colorName: 'gray', border: 'border_sidewalk_1000x200x80_gray'}, 
                                    {colorName: 'white', border: 'border_swivel_500x200x80_granit_white'}
                                ]
                            },
                            80:{
                                default: 'white',
                                colors: [{colorName: 'white', border: 'border_swivel_500x200x80_granit_white'}]
                            },
                        }
                    },
                }
            },
            sleek: {
                name: "Гладкий",
                pathName: 'sleek',
                collections: {
                    colormix: {
                        isDefault: true,
                        name: 'Колормикс',
                        pathName: 'colormix',
                        depth: {
                            40:{
                                isDefault: true,
                                default: 'antracit',
                                colors: [
                                    {colorName: 'antracit', border: 'border_sidewalk_1000x200x80_granit_antracit'}, 
                                    {colorName: 'husky', border: 'border_sidewalk_1000x200x80_granit_husky'}, 
                                    {colorName: 'autumn', border: 'border_sidewalk_1000x200x80_granit_autumn'}, 
                                    {colorName: 'old_castel', border: 'border_sidewalk_1000x200x80_granit_old_castel'}, 
                                    {colorName: 'maple', border: 'border_swivel_500x200x80_granit_arabian_night'}
                                ]
                            },
                            60:{
                                default: 'husky',
                                colors: [
                                    {colorName: 'husky', border: 'border_sidewalk_1000x200x80_granit_husky'}, 
                                    {colorName: 'antracit', border: 'border_sidewalk_1000x200x80_granit_antracit'}, 
                                    {colorName: 'old_castel', border: 'border_sidewalk_1000x200x80_granit_old_castel'},
                                    {colorName: 'autumn', border: 'border_sidewalk_1000x200x80_granit_autumn'}, 
                                    {colorName: 'arabian_night', border: 'border_swivel_500x200x80_granit_arabian_night'}
                                ]
                            },
                            80:{
                                default: 'maple',
                                colors: [{colorName: 'maple', border: 'border_swivel_500x200x80_granit_white'}]
                            },
                        }
                    },
                }
            },
            artificial_stone: {
                isDefault: true,
                name: "Искусственный камень",
                pathName: 'artificial_stone',
                collections: {
                    colormix: {
                        isDefault: true,
                        name: 'Колормикс',
                        pathName: 'colormix',
                        depth: {
                            40:{
                                isDefault: true,
                                default: 'dolomit',
                                colors: [
                                    {colorName: 'dolomit', border: 'border_swivel_500x200x80_granit_white'}, 
                                    {colorName: 'stepnyak', border: 'border_sidewalk_1000x200x80_stepnyak'}, 
                                    {colorName: 'shungite', border: 'border_swivel_500x200x80_granit_white'}
                                ]
                            },
                            60:{
                                default: 'dolomit',
                                colors: [
                                    {colorName: 'dolomit', border: 'border_swivel_500x200x80_granit_white'}, 
                                    {colorName: 'stepnyak', border: 'border_sidewalk_1000x200x80_stepnyak'}, 
                                    {colorName: 'shungite', border: 'border_swivel_500x200x80_granit_white'}
                                ]
                            },
                        }
                    },
                }
            }
        }
    },
    trio: {
        name: 'ТРИО',
        images: [{
            isDefault: true,
            name: "ТРИО",
            pathName: "trio"
        }],
        factures: {
            artificial_stone: {
                isDefault: true,
                name: "Искусственный камень",
                pathName: 'artificial_stone',
                collections: {
                    colormix: {
                        isDefault: true,
                        name: 'Колормикс',
                        pathName: 'colormix',
                        depth: {
                            60:{
                                isDefault: true,
                                default: 'stepnyak',
                                colors: [
                                    {colorName: 'stepnyak', border: 'border_sidewalk_1000x200x80_stepnyak'},  
                                    {colorName: 'shungite', border: 'border_swivel_500x200x80_granit_arabian_night'}
                                ]
                            },
                        }
                    },
                }
            },
            sleek: {
                name: "Гладкий",
                pathName: 'sleek',
                collections: {
                    colormix: {
                        isDefault: true,
                        name: 'Колормикс',
                        pathName: 'colormix',
                        depth: {
                            60:{
                                isDefault: true,
                                default: 'old_castel',
                                colors: [
                                    {colorName: 'old_castel', border: 'border_sidewalk_1000x200x80_granit_old_castel'}, 
                                    {colorName: 'antracit', border: 'border_sidewalk_1000x200x80_granit_antracit'}
                                ]
                            },
                        }
                    },
                }
            },
        }
    },
}

// export const border = {
//     "border_swivel_500x200x80_granit_white" : [

//     ]
// }